import _ from 'lodash';


const ENV_MAX_LEVEL = {
  live: 80,
  test: 90,
  beta: 90,
};

export const MAX_LEVEL = ENV_MAX_LEVEL[process.env.RAIDBOTS_ENV || 'live'];

// https://trinitycore.atlassian.net/wiki/display/tc/item_template
export const SLOT_MAP = {
  1: 'head',
  2: 'neck',
  3: 'shoulder',
  4: 'shirt',
  5: 'chest',
  6: 'waist',
  7: 'legs',
  8: 'feet',
  9: 'wrist',
  10: 'hands',
  11: 'finger',
  12: 'trinket',
  13: 'main_hand', // weapon
  14: 'off_hand', // shield
  15: 'main_hand',
  16: 'back',
  17: 'main_hand', // two-hand
  // 18 is bags
  19: 'tabard',
  20: 'chest',
  21: 'main_hand',
  22: 'off_hand',
  23: 'off_hand',
  // 24 is ammo
  // 25 is thrown
  26: 'main_hand', // some ranged weapons
  // 27 is quiver
  28: 'off_hand', // relic
};

export const SCALING_MAP = {
  '-1': 'Item',
  '-2': 'Consumable',
  '-3': 'Gem1',
  '-4': 'Gem2',
  '-5': 'Gem3',
  '-6': 'Health',
  '-7': 'Item',
  '-8': 'DamageReplaceStat',
  '-9': 'DamageReplaceStat',
};

export const SOCKET_TYPES = {
  PRISMATIC: 'PRISMATIC',
  DOMINATION: 'DOMINATION',
  PRIMORDIAL: 'PRIMORDIAL',
  TINKER: 'TINKER',
  CITRINE_THUNDER: 'CITRINE_THUNDER',
  CITRINE_SEA: 'CITRINE_SEA',
  CITRINE_WIND: 'CITRINE_WIND',
  FIBER: 'FIBER',
};

export const SOCKET_COLORS = {
  1: 'META',
  2: 'RED',
  4: 'YELLOW',
  6: 'ORANGE',
  7: 'PRISMATIC',
  8: 'BLUE',
  10: 'PURPLE',
  12: 'YELLOW',
  14: 'PRISMATIC',
  19: 'RED_PUNCHCARD',
  20: 'YELLOW_PUNCHCARD',
  21: 'BLUE_PUNCHCARD',
  22: 'DOMINATION',
  23: 'SPHEROID',
  24: 'TINKER',
  25: 'PRIMORDIAL',
  27: 'CITRINE_THUNDER',
  28: 'CITRINE_SEA',
  29: 'CITRINE_WIND',
  30: 'FIBER',
};

export const GEM_TO_SOCKET = {
  // Core prismatic gems
  //0x1: 'META',
  0x2: 'PRISMATIC', // red
  0x4: 'PRISMATIC', // yellow
  0x8: 'PRISMATIC', // blue

  // BfA
  //0x20000: 'RED_PUNCHCARD',
  //0x40000: 'YELLOW_PUNCHCARD',
  //0x80000: 'BLUE_PUNCHCARD',

  // Shadowlands
  //0x100000: 'DOMINATION',
  //0x800000: 'SPHEROID',

  // Dragonflight
  0x1000000: 'TINKER', // engineering
  0x2000000: 'PRIMORDIAL', // 10.0.7

  // The War Within
  0x08000000: 'CITRINE_THUNDER',
  0x10000000: 'CITRINE_SEA',
  0x20000000: 'CITRINE_WIND',

  0x40000000: 'FIBER',
};

export const ALGARI_COLOR_COMBO_MAX = 4;

const EXPANSION_DATA = [{
  id: -3,
  name: 'Event / Trading Post',
  enumName: 'EVENT',
}, {
  id: 0,
  name: 'Vanilla',
  enumName: 'VANILLA',
}, {
  id: 1,
  name: 'The Burning Crusade',
  enumName: 'BURNING_CRUSADE',
}, {
  id: 2,
  name: 'Wrath of the Lich King',
  enumName: 'WRATH',
}, {
  id: 3,
  name: 'Cataclysm',
  enumName: 'CATACLYSM',
}, {
  id: 4,
  name: 'Mists of Pandaria',
  enumName: 'MISTS',
}, {
  id: 5,
  name: 'Warlords of Draenor',
  enumName: 'WARLORDS',
}, {
  id: 6,
  name: 'Legion',
  enumName: 'LEGION',
}, {
  id: 7,
  name: 'Battle for Azeroth',
  enumName: 'BFA',
}, {
  id: 8,
  name: 'Shadowlands',
  enumName: 'SHADOWLANDS',
}, {
  id: 9,
  name: 'Dragonflight',
  enumName: 'DRAGONFLIGHT',
}, {
  id: 10,
  name: 'The War Within',
  enumName: 'WAR_WITHIN',
}, {
  id: 11,
  name: 'Midnight',
  enumName: 'MIDNIGHT',
}, {
  id: 12,
  name: 'The Last Titan',
  enumName: 'LAST_TITAN',
}];

export const EXPANSIONS = new Proxy(
  EXPANSION_DATA,
  {
    // lookups can use expansion ID or enum name
    get(target, prop) {
      return _.find(target, { id: parseInt(prop, 10) })
        || _.find(target, { enumName: prop });
    },
  },
);

const envExpansions = {
  live: EXPANSIONS.WAR_WITHIN,
  test: EXPANSIONS.MIDNIGHT,
  beta: EXPANSIONS.MIDNIGHT,
};

const env = process.env.RAIDBOTS_ENV || 'live';

export const CURRENT_EXPANSION = envExpansions[env];

// Try to have no overlap here since it can get messy
export const FAKE_INSTANCE_IDS = {
  mplus: -1,
  azeriteVendor: -2,
  benthicItems: -3,
  mechagonJunkyard: -14,
  mechagonWorkshop: -15,
  pvpHonorShadowlandsSeason1: -16,
  pvpConquestShadowlandsSeason1: -17,
  korthiaItems: -18,
  legionTimewalking: -19,
  tazaveshStreets: -20,
  tazaveshSoleah: -21,
  creationCatalyst: -22,
  sandwornRelic: -25,
  karazhanLower: -26,
  karazhanUpper: -27,
  season4RaidVendor: -28,
  shadowlandsPvpSeason3: -29,
  pvpHonorDragonflightSeason1: -30,
  pvpConquestDragonflightSeason1: -31,
  expansionDungeons: -32,

  dragonflightBlacksmithing: -33,
  dragonflightEnchanting: -34,
  dragonflightEngineering: -35,
  dragonflightInscription: -36,
  dragonflightJewelcrafting: -37,
  dragonflightLeatherworking: -38,
  dragonflightTailoring: -39,

  dragonflightProfessions333: -41,
  dragonflightProfessions382: -42,

  dragonflightAlchemy: -43,

  boeVaultTrash: -44, // placeholder

  primalStorms: -45,

  catalystDragonflight1: -46,

  pvpHonorDragonflightSeason2: -47,
  pvpConquestDragonflightSeason2: -48,
  boeAberrusTrash: -49,

  // 10.1.5 solo content
  timeRifts: -50,

  // 10.1.7 solo content
  dreamsurges: -51,

  // 10.2 PVP
  pvpHonorDragonflightSeason3: -52,
  pvpConquestDragonflightSeason3: -53,
  boeAmirdrassilTrash: -54,

  dawnFall: -55,
  dawnRise: -56,

  pvpWorldDragonflightSeason3: -57,

  dfSeason4RaidVendor: -58,

  pvpHonorDragonflightSeason4: -59,
  pvpConquestDragonflightSeason4: -60,
  pvpWorldDragonflightSeason4: -61,

  pvpHonorWarWithinSeason1: -62,
  pvpConquestWarWithinSeason1: -63,
  pvpWorldWarWithinSeason1: -64,

  warWithinProfessionsRare: -65,
  warWithinProfessionsEpic: -66,

  boeNerubarTrash: -67,

  delveRaresWarWithinSeason1: -68,
  delveEpicsWarWithinSeason1: -69,

  catalystWarWithinSeason1: -70,
  catalystWarWithinSeason2: -71,

  pvpHonorWarWithinSeason2: -72,
  pvpConquestWarWithinSeason2: -73,
  pvpWorldWarWithinSeason2: -74,

  boeUndermineTrash: -75,

  twwNightfall: -76,

  puzzlingCartelChips: -77,

  boeManaforgeTrash: -78,

  pvpHonorWarWithinSeason3: -79,
  pvpConquestWarWithinSeason3: -80,
  pvpWorldWarWithinSeason3: -81,

  catalystWarWithinSeason3: -82,

  puzzlingCartelChipsWarWithinSeason3: -83,
};

export const FAKE_ENCOUNTER_IDS = {
  relinquishedShoulders: -2,
  relinquishedHelms: -3,
  relinquishedChests: -4,
  benthicHelm: -5,
  benthicShoulders: -6,
  benthicChest: -7,
  benthicLegs: -8,
  benthicBelt: -9,
  benthicWrists: -10,
  benthicCloak: -11,
  benthicFeet: -12,
  benthicGloves: -13,
  pvpHonorShadowlandsSeason1: -14,
  pvpConquestShadowlandsSeason1: -15,
  boeSanctumTrash: -16,
  boeNathriaTrash: -17,
  korthiaItems: -18,
  legionTimewalking: -19,
  // 20 and 21 are tazavesh split
  creationCatalyst: -23,
  boeSepulcherTrash: -24,
  sandwornRelic: -25,
  karazhanLower: -26,
  karazhanUpper: -27,
  season4RaidVendor: -28,
  shadowlandsPvpSeason3: -29,
  pvpHonorDragonflightSeason1: -30,
  pvpConquestDragonflightSeason1: -31,
  expansionDungeonsNotUsed: -32,

  dragonflightBlacksmithing: -33,
  dragonflightEnchanting: -34,
  dragonflightEngineering: -35,
  dragonflightInscription: -36,
  dragonflightJewelcrafting: -37,
  dragonflightLeatherworking: -38,
  dragonflightTailoring: -39,

  dragonflightProfessions333: -41,
  dragonflightProfessions382: -42,

  dragonflightAlchemy: -43,

  boeVaultTrash: -44,
  primalStorms: -45,

  catalystDragonflight1: -46,

  pvpHonorDragonflightSeason2: -47,
  pvpConquestDragonflightSeason2: -48,
  boeAberrusTrash: -49,

  // 10.1.5 solo content
  timeRifts: -50,

  // 10.1.7 solo content
  dreamsurges: -51,

  // 10.2 PVP
  pvpHonorDragonflightSeason3: -52,
  pvpConquestDragonflightSeason3: -53,
  boeAmirdrassilTrash: -54,

  dawnFall: -55,
  dawnRise: -56,

  pvpWorldDragonflightSeason3: -57,

  dfSeason4RaidVendor: -58,

  pvpHonorDragonflightSeason4: -59,
  pvpConquestDragonflightSeason4: -60,
  pvpWorldDragonflightSeason4: -61,

  pvpHonorWarWithinSeason1: -62,
  pvpConquestWarWithinSeason1: -63,
  pvpWorldWarWithinSeason1: -64,

  warWithinProfessionsRare: -65,
  warWithinProfessionsEpic: -66,

  boeNerubarTrash: -67,

  delveRaresWarWithinSeason1: -68,
  delveEpicsWarWithinSeason1: -69,

  catalystWarWithinSeason1: -70,
  catalystWarWithinSeason2: -71,

  pvpHonorWarWithinSeason2: -72,
  pvpConquestWarWithinSeason2: -73,
  pvpWorldWarWithinSeason2: -74,

  boeUndermineTrash: -75,

  twwNightfall: -76,

  puzzlingCartelChips: -77,

  boeManaforgeTrash: -78,

  pvpHonorWarWithinSeason3: -79,
  pvpConquestWarWithinSeason3: -80,
  pvpWorldWarWithinSeason3: -81,

  catalystWarWithinSeason3: -82,

  puzzlingCartelChipsWarWithinSeason3: -83,
};

export const SEASONS = [{
  id: 30,

  active: true,

  name: 'The War Within Season 3',
  shortName: 'tww3',

  journalTierAvailabilityCondition: 141987, // check JournalTierXInstance
  currentWorldStateExpression: 48764, // check JournalEncounterItem for current one

  bonusListGroups: [
    513, // Explorer
    514, // Adventurer
    515, // Veteran
    516, // Champion
    517, // Hero
    518, // Myth
  ],

  itemConversionId: 11,
  itemConversionCurrency: 3269, // Ethereal Voidsplinter

  crestCurrencies: [
    3284, // Weathered Ethereal Crest
    3286, // Carved Ethereal Crest
    3288, // Runed Ethereal Crest
    3290, // Gilded Ethereal Crest
  ],
  upgradeItems: [
    231756, // Spark of Starlight
    231767, // Enchanted Weathered Ethereal Crest
    231769, // Enchanted Runed Ethereal Crest
    231768, // Enchanted Gilded Ethereal Crest
  ],

  // any slots that have a static legendary that will always be used
  // e.g. Reshii Wraps in 11.2
  staticLegendarySlots: ['back'],

  // used for warnings about slots without enchants
  // this can change season-to-season (head enchants in 11.1 but not 11.2 because of corruptions stuff)
  dpsEnchantSlots: [
    'main_hand',
    'off_hand',
    'chest',
    'feet',
    'rings',
    'hands',
    'wrist',
    'legs',
    'waist',
  ],

  craftedSocketSlots: [
    'neck',
    'finger',
  ],
}, {
  id: 25,

  name: 'The War Within Season 2',
  shortName: 'tww2',

  journalTierAvailabilityCondition: 128527, // check JournalTierXInstance

  bonusListGroups: [
    437, // Explorer
    438, // Adventurer
    439, // Veteran
    440, // Champion
    441, // Hero
    442, // Myth
  ],

  itemConversionId: 10,
  itemConversionCurrency: 3116, // Essence of Kaja'mite

  upgradeItems: [
    230906, // Spark of Fortunes
    230937, // Enchanted Weathered Undermine Crest
    230936, // Enchanted Runed Undermine Crest
    230935, // Enchanted Gilded Undermine Crest
  ],

  // TODO: Figure out if this is 99 or 100
  // milestoneSeasonId: 99,
}, {
  id: 24,

  name: 'The War Within Season 1',
  shortName: 'tww1',

  journalTierAvailabilityCondition: 125989,

  bonusListGroups: [
    329, // Explorer
    330, // Adventurer
    331, // Veteran
    332, // Champion
    333, // Hero
    334, // Myth
  ],

  itemConversionId: 8,
  itemConversionCurrency: 2813, // Harmonized Silk

  // TODO: Figure out if this is 99 or 100
  // milestoneSeasonId: 99,
}, {
  id: 23,
  milestoneSeasonId: 94,

  name: 'Dragonflight Season 4',
  shortName: 'df4',

  journalTierAvailabilityCondition: 117114,

  itemConversionId: 9,
}, {
  id: 22,
  milestoneSeasonId: 93,

  name: 'Dragonflight Season 3',
  shortName: 'df3',

  itemConversionId: 7,
}, {
  id: 21,
  milestoneSeasonId: 92,

  name: 'Dragonflight Season 2',
  shortName: 'df2',
}, {
  id: 19,
  milestoneSeasonId: 91,

  name: 'Dragonflight Season 1',
  shortName: 'df1',
}];

export const CURRENT_SEASON = _.find(SEASONS, { active: true });
